// [NEW FILE] PM-8: employees see only their own audit trail ("My activity"). The full audit trail stays with
// Admin / IT Admin (Admin › Audit trail).
import { useMemo, useState } from "react";
import useAsync from "../../hooks/useAsync";
import { getMyActivity } from "../../services/activityApi";
import { Card, PageHeader, DataTable, SearchInput, ErrorState, Banner } from "../../components/common";
import { formatDateTime } from "../../utils/format";

export default function MyActivityPage() {
  const { data, loading, error, reload } = useAsync(() => getMyActivity(), []);
  const [search, setSearch] = useState("");
  const rows = useMemo(() => {
    const q = search.trim().toLowerCase();
    return (data || []).filter((r) => !q || `${r.text} ${r.by} ${r.reason} ${r.cycleName}`.toLowerCase().includes(q));
  }, [data, search]);

  if (error) return <ErrorState message={error} onRetry={reload} />;
  return (
    <div className="page">
      <PageHeader title="My activity" subtitle="Everything that happened on your own appraisals, newest first. Only you (and administrators) can see this." />
      <Banner tone="neutral" title="Your own records only">
        This is your personal audit trail: goals, approvals, assessments, results and deadline changes on your appraisals.
      </Banner>
      <div className="filter-bar"><SearchInput value={search} onChange={setSearch} placeholder="Search activity" /></div>
      <Card padded={false}>
        <DataTable
          label="My activity"
          keepOrder
          rowKey="key"
          rows={rows}
          loading={loading && !data}
          emptyTitle="No activity yet"
          emptyText="Events appear here when you or your manager work on your appraisal."
          columns={[
            { key: "at", label: "When", render: (r) => formatDateTime(r.at) },
            { key: "text", label: "What happened", render: (r) => <span className="cell-stack"><strong>{r.text}</strong>{r.reason && <small>{r.reason}</small>}</span> },
            { key: "by", label: "By" },
            { key: "cycleName", label: "Cycle" },
          ]}
        />
      </Card>
    </div>
  );
}
